export default __webpack_public_path__ + "static/media/recycle.399b7a3e.png";